import { toast } from 'react-toastify';

/**
 * Thin wrapper around react-toastify so call sites don't import the library
 * directly. `<ToastContainer />` is mounted once in `App.js`.
 */
const baseOptions = { position: 'top-right', autoClose: 4000 };

export const toastSuccess = (message, options) => toast.success(message, { ...baseOptions, ...options });
export const toastError = (message, options) =>
  toast.error(message || 'Something went wrong', { ...baseOptions, ...options });
export const toastInfo = (message, options) => toast.info(message, { ...baseOptions, ...options });

/**
 * "You can't do this — here's why" — the permission-denied message.
 *
 * Always fired under ONE toastId, so a denial never stacks: React.StrictMode
 * double-invokes effects in development (two identical toasts from a single
 * click, which is how this was first noticed), and clicking a withheld control
 * repeatedly would otherwise pile up a message per click. react-toastify treats
 * a repeat of the same id as the same toast, so the newest one just refreshes.
 *
 * Use this rather than toastInfo for anything the permission matrix refused.
 */
export const PERMISSION_TOAST_ID = 'permission-denied';
export const toastPermission = (message) =>
  toastInfo(message, { toastId: PERMISSION_TOAST_ID });
